import { render, staticRenderFns } from "./ScrollLeftBySchool.vue?vue&type=template&id=8c4ab156&scoped=true&"
import script from "./ScrollLeftBySchool.vue?vue&type=script&lang=js&"
export * from "./ScrollLeftBySchool.vue?vue&type=script&lang=js&"
import style0 from "./ScrollLeftBySchool.vue?vue&type=style&index=0&id=8c4ab156&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4ab156",
  null
  
)

export default component.exports